export enum Currency {
  NOK = 'NOK',
  SEK = 'SEK',
  DKK = 'DKK',
  EUR = 'EUR',
}
